const billReports = {
  description:
    'Fornece uma visão geral dos detalhes da viagem e dos passageiros, incluindo a logística da viagem, status e métricas-chave para faturamento e auditoria dos serviços de transporte.',
  actions: {
    export: 'Export',
  },

  table: {
    headers: {
      tripId: 'ID da Viagem',
      jobId: 'ID da Reserva',
      waitAndReturn: 'Aguardar e Retornar',
      externalId: 'ID Externo',
      jobStatus: 'Status da Reserva',
      actualPickupTime: 'Horário Real de Coleta',
      actualDropTime: 'Horário Real de Entrega',
      plannedPickupTime: 'Horário Planejado de Coleta',
      plannedDropTime: 'Horário Planejado de Entrega',
      canceledBy: 'Cancelado por',
      assignedBy: 'Atribuído por',
      routeId: 'ID da Rota',
      tripStatus: 'Status da Viagem',
      isShared: 'Compartilhado',
      supplier: 'Fornecedor',
      areas: 'Zonas',
      from: 'De',
      to: 'Para',
      date: 'Data',
      driver: 'Motorista',
      vehicle: 'Veículo',
      profile: 'Perfil',
      passenger: 'Passageiro',
      email: 'E-mail',
      phone: 'Telefone',
      attributes: 'Atributo',
      cost: 'Custo',
    },

    cells: {
      reservationStatus: {
        options: {
          new: 'New',
          onhold: 'On Hold',
          cancelled: 'Cancelled',
          routing: 'Routing',
          routed: 'Routed',
          picked: 'Picked',
          dropped: 'Dropped',
          noshow: 'Noshow',
        },
      },
    },

    filters: {
      assigned: {
        automated: 'Automated Assigned',
        manually: 'Manual Assigned',
        manuallyIntegration: 'Manually Assigned (Integration)',
        all: 'Automated & Manually Assigned',
      },
      shared: {
        onlyWithout: 'Not Shared',
        onlyWith: 'Shared',
        all: 'Shared & Not Shared',
      },

      tripStatus: 'Estados da Viagem',
      jobStatus: 'Estados da Reserva',
      vehicles: 'Vehicles',
      drivers: 'Drivers',
      suppliers: 'Fornecedores',
      profiles: 'Perfil',
      areas: 'Zonas',
      locations: 'Localizações',
      airportLocations: 'Localizações de Aeroporto',
      attributes: 'Atributo',
    },
  },
  tableSummary: {
    title: 'Shuttle Reports',
    headers: {
      trips: 'Viagens',
      jobs: 'Reserva',
      vehicles: 'Veículos',
      shared: 'Compartilhado',
      autoAssigned: 'Atribuído Automaticamente',
      waitAndReturn: 'Aguardar e Retornar',
    },
  },
};

export default billReports;
